import React from 'react';
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import PageHeader from "../components/PageHeader";
import About from "../components/about";
import Footer from "../components/Footer";


const AboutPage = () => {
    return (
        <Layout pageTitle="苏州卫捷 | 关于我们">
            <NavOne />
            <PageHeader title="关于我们" />
            <About />
            <Footer />
        </Layout>
    );
};

export default AboutPage;
